import { render, staticRenderFns } from "./aRoomTypeCard.vue?vue&type=template&id=94dbcbc2&scoped=true"
import script from "./aRoomTypeCard.vue?vue&type=script&lang=js"
export * from "./aRoomTypeCard.vue?vue&type=script&lang=js"
import style0 from "./aRoomTypeCard.vue?vue&type=style&index=0&id=94dbcbc2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "94dbcbc2",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VTooltip } from 'vuetify/lib/components/VTooltip';
installComponents(component, {VTooltip})
